import { GameSave } from '@prometheus/types'

export const fixSaveGame = (save: GameSave, id: string, uid: string) => {
  save.game.id = id
  save.metadata.paused_by = uid
  save.game.status = 'loading'
  save.game.owner = uid
  return save
}
